import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { P as PeekabooStickyTabButton } from './PeekabooStickyTab.styles-bb92c35c.js';

const PeekabooStickyTab = ({
  position,
  side,
  startOffset,
  endOffset,
  ...rest
}) => /*#__PURE__*/React__default.createElement(PeekabooStickyTabButton, _extends({}, rest, {
  $position: position,
  $side: side,
  $startOffset: startOffset,
  $endOffset: endOffset
}));
PeekabooStickyTab.defaultProps = {
  position: 'fixed',
  side: 'end',
  startOffset: undefined,
  endOffset: '0',
  disabled: false
};
var PeekabooStickyTab$1 = PeekabooStickyTab;

export { PeekabooStickyTab$1 as P };
//# sourceMappingURL=PeekabooStickyTab-b3b295f4.js.map
